export const validateImageFileType = (file, allowedTypes) => {
  return file && allowedTypes.includes(file.type);
};

export const sortByDateCreated = (data, dateFieldPath) => {
  if (!Array.isArray(data)) {
    console.error("Invalid input: data should be an array.");
    return [];
  }
  return data.sort((a, b) => {
    const getValue = (obj, path) => {
      return path.split('.').reduce((acc, key) => {
        if (acc && acc[key] !== undefined) {
          return acc[key];
        }
        return null;
      }, obj);
    };
    const dateA = new Date(getValue(a, dateFieldPath));
    const dateB = new Date(getValue(b, dateFieldPath));
    if (isNaN(dateA) || isNaN(dateB)) return 0;
    return dateB - dateA;
  });
};



// WEBPACK FOOTER //
// ./src/helpers/utils.js